import CouponsActionTypes from 'redux/coupon/types';

// fetch coupons
export const startFetchCoupons = (data) => ({
  type: CouponsActionTypes.START_FETCH_COUPONS,
  payload: data,
});

export const fetchCouponsSuccess = (coupons) => ({
  type: CouponsActionTypes.FETCH_COUPONS_SUCCESS,
  payload: coupons,
});

export const fetchCouponsFailure = (error) => ({
  type: CouponsActionTypes.FETCH_COUPONS_FAILURE,
  payload: error,
});

// fetch single coupon
export const fetchSingleCoupon = (id, data) => ({
  type: CouponsActionTypes.FETCH_SINGLE_COUPON,
  payload: {id, data},
});

export const fetchSingleCouponSuccess = (data) => ({
  type: CouponsActionTypes.FETCH_SINGLE_COUPON_SUCCESS,
  payload: data,
});

export const fetchSingleCouponFailure = (error) => ({
  type: CouponsActionTypes.FETCH_SINGLE_COUPON_FAILURE,
  payload: error,
});


// create coupon
export const startCreateCoupons = (data, cb) => ({
  type: CouponsActionTypes.START_CREATE_COUPON,
  payload: { data, cb },
});

export const createCouponsSuccess = (forms) => ({
  type: CouponsActionTypes.CREATE_COUPON_SUCCESS,
  payload: forms,
});

export const createCouponFailure = (error) => ({
  type: CouponsActionTypes.CREATE_COUPON_FAILURE,
  payload: error,
});

// set any data action
export const setAnyData = (payload) => ({
  type: CouponsActionTypes.SET_ANY_DATA,
  payload,
});

// export coupon
export const exportCoupon = (data, id, cb) => ({
  type: CouponsActionTypes.EXPORT_COUPON_START,
  payload: { data, id, cb },
});
export const exportCouponSuccess = () => ({
  type: CouponsActionTypes.EXPORT_COUPON_SUCCESS,
});
export const exportCouponFailure = (error) => ({
  type: CouponsActionTypes.EXPORT_COUPON_FAILURE,
  error,
});